import React, { useEffect, useState } from "react";
import {
  ITabDetail,
  Tabcontroller,
} from "../../../../core/components/tab-controller/tab-controller";
import { AddNoteActivity } from "./add-note-activity";
import { AddFileActivity } from "./add-file-activity";
import { useLeadActivities } from "../../../../core/hooks/useLeadActivities";
import api from "../../../../api";
import { PlannedActivities } from "./planned-activities";
import { DoneActivities } from "./done-activities";
import {
  useHasPermission,
  AppPermissions,
  getInvalidCustomerFieldsEnquiry,
} from "../../../../core";
import { useAppSettings } from "../../../../core/hooks/useAppSettings";
import { useMasterData } from "../../../../core/hooks/useMasterData";

interface IActivityProps {
  addActivity?: () => void;
  id: string;
  name?: string;
  onUpdate?: () => void;
  onReload?: () => void;
}

export const LeadActivities: React.FunctionComponent<IActivityProps> = (
  props
) => {
  const appSettings = useAppSettings(api.settings);
  const masterData = useMasterData(api.settings);
  const { leadState, getAllLeadActivities } = useLeadActivities(api.lead);
  const canCreateLeadActivity =
    useHasPermission(AppPermissions.CreateLeadActivity) &&
    leadState?.leadDetails?.isEditable &&
    !leadState.leadDetails?.customer?.isBlocked;
  useEffect(() => {
    getAllLeadActivities(props.id, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const plannedActivities = leadState.plannedActivities;
  const doneActivities = leadState.doneActivities;

  const [tabs, setTabs] = useState<ITabDetail[]>([
    {
      text: "Note",
      icon: "icon-note",
      isActive: true,
      content: (
        <AddNoteActivity
          leadId={props.id!}
          onSubmitCompleted={props.onUpdate}
        ></AddNoteActivity>
      ),
    },
    // {
    //   text: 'Activity',
    //   icon: 'icon-activity',
    //   content: (
    //     <AddActivityWraper
    //       leadId={props.id}
    //       //  activity={activity}
    //     ></AddActivityWraper>
    //   ),
    // },
    {
      text: "Files",
      icon: "icon-attach",
      content: (
        <AddFileActivity
          leadId={props.id}
          onSubmitCompleted={props.onUpdate}
        ></AddFileActivity>
      ),
    },
    // { text: 'Invoice', icon: 'icon-invoice', content: <div></div> },
  ]);

  return (
    <div className="col-md-4 col-12">
      <div className="d-flex border-bottom align-items-center py-2 px-4">
        <h6 className="mb-0">Activity </h6>
        <i className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto hide-visibility"></i>
      </div>

      {canCreateLeadActivity && (
        <Tabcontroller
          onChange={(index: number) => {
            const clone = [...tabs];
            clone.forEach((p, i) => {
              i === index ? (p.isActive = true) : (p.isActive = false);
            });
          }}
          tabs={tabs}
        ></Tabcontroller>
      )}

      <ul className={`activity-timeline list-unstyled mt-5 px-4 position-relative ${
          plannedActivities?.data?.length === 0 ? "hide-line" : ""
        }`}>
        <PlannedActivities
          activityDetails={plannedActivities}
          customer={leadState.leadDetails?.customer}
          onReload={props.onReload}
          addActivity={props.addActivity}
        ></PlannedActivities>
        <DoneActivities
          activityDetails={doneActivities}
          customerId={leadState?.leadDetails?.customer?._id}
        ></DoneActivities>
      </ul>
    </div>
  );
};
